/**
 * Datas das folhas de apontamento: "dd/mm/aaaa" e o dia da semana por
 * extenso em pt-BR.
 *
 * Tudo parte do ISO "AAAA-MM-DD" que o leitor da planilha entrega e passa
 * pelo calendário da Capacidade, que faz a conta pelo número do dia e não
 * depende do fuso. Nunca `new Date("AAAA-MM-DD")`: é meia-noite UTC e, em
 * São Paulo, vira o dia anterior (ADR-0059).
 */
import { diaDaSemana as numeroDoDiaDaSemana, ehIsoValido } from "../capacidade/calendario";

const POR_EXTENSO = [
  "domingo",
  "segunda-feira",
  "terça-feira",
  "quarta-feira",
  "quinta-feira",
  "sexta-feira",
  "sábado",
];

/** "quarta-feira"; vazio para o que não é data. */
export function diaDaSemanaPorExtenso(iso) {
  if (!ehIsoValido(iso)) return "";
  return POR_EXTENSO[numeroDoDiaDaSemana(iso)];
}

/** "quarta" (sem o "-feira"), para as mensagens de aviso. */
export function diaDaSemanaCurto(iso) {
  return diaDaSemanaPorExtenso(iso).replace("-feira", "");
}

/** "28/10/2026"; vazio para o que não é data. */
export function formatarData(iso) {
  if (!ehIsoValido(iso)) return "";
  const [ano, mes, dia] = iso.split("-");
  return `${dia}/${mes}/${ano}`;
}

/** "28/10, quarta", o formato curto dos avisos. */
export function formatarDataComDia(iso) {
  if (!ehIsoValido(iso)) return "";
  const [, mes, dia] = iso.split("-");
  return `${dia}/${mes}, ${diaDaSemanaCurto(iso)}`;
}
